import { render, staticRenderFns } from "./PacOptionalInputBox.vue?vue&type=template&id=03c5de88&scoped=true"
import script from "./PacOptionalInputBox.vue?vue&type=script&lang=ts"
export * from "./PacOptionalInputBox.vue?vue&type=script&lang=ts"
import style0 from "./PacOptionalInputBox.vue?vue&type=style&index=0&id=03c5de88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c5de88",
  null
  
)

export default component.exports